import { TableChartConfigDto, BattingStatsChartDataDto } from 'types/CodegenReportTypes';
import Table, { Order } from 'components/Table/Table';
import { getDisplayedColumns, tableHeaders } from 'utilities/tableHeaders';

import { ChartProps } from 'utilities/chartIdToComponent';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type BattingStatsChartColumn = keyof BattingStatsChartDataDto['battingStats'][number];

const BatterBattingStatsChart = ({ chartData, isLoading, chartConfig }: ChartProps<BattingStatsChartDataDto, TableChartConfigDto>) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<BattingStatsChartColumn | '' | 'id'>('');

  const rows = useMemo(
    () =>
      chartData?.battingStats.length
        ? [
            {
              ...chartData.battingStats[0],
              id: '0',
            },
          ]
        : [],
    [chartData?.battingStats]
  );

  const columns = useMemo(() => {
    const displayedColumns = getDisplayedColumns<BattingStatsChartColumn>(chartConfig.visibleStats);

    return displayedColumns.map((column) => ({
      ...tableHeaders[column],
      field: column,
      headerName: t(column),
      headerShortName: t('short.' + column),
      sortable: true,
    }));
  }, [chartConfig.visibleStats]);

  return (
    <Table
      rows={rows}
      pageState={[page, setPage]}
      orderState={[order, setOrder]}
      orderByState={[orderBy, setOrderBy]}
      columns={columns}
      loading={isLoading}
      noFooter
      tileTable
      skeletonRows={1}
    />
  );
};

export default BatterBattingStatsChart;
